const FEATURE_FLAGS = {
  POINTS_WITHDRAW: "Store_Dashboard_Points_Withdraw",
  PROFIT_PERCENTAGE: "Store_Dashboard_Profit_Percentage",
  INTERNAL_ADMIN: "STOR_3649_INTERNAL_ADMIN",
  SUPPORT_ADS: "STOR-4132-support-ads-in-dashboard"
} as const;

export default FEATURE_FLAGS;
